import LangEnum from '../../../../../../lang/LangEnum';
import { Summary } from '../../../../products/orderProducts.types';

const ITEM_DISCOUNTS_ROW_KEY = 'itemDiscounts';
const DISCOUNTS_ROW_KEY = 'discounts';
const PRICE_COMPOSITION_ROW_PREFIX = 'composition-';
export const TOTAL_NET_VALUE_ROW_KEY = 'totalNetValue';

const hasRecordedValue = (value?: number): value is number => Number.isFinite(value);

export interface OrderTotalsSummaryValueRow {
  key: string;
  label: LangEnum;
  labelText?: string;
  value: number;
  sign?: '-' | '+';
  prefix?: '(-)' | '(+)' | '(=)';
  isNested?: boolean;
  isLastNested?: boolean;
  isEmphasized?: boolean;
}

interface BuildOrderTotalsValueRowsParams {
  totals: Summary;
  showCharges: boolean;
  showShippingCost: boolean;
}

export const calcTotalMarkup = (totalRetail: number, total: number) => {
  if (total === 0) {
    return 0;
  }

  return totalRetail / total;
};

export const buildOrderTotalsValueRows = ({
  totals,
  showCharges,
  showShippingCost,
}: BuildOrderTotalsValueRowsParams): OrderTotalsSummaryValueRow[] => {
  const rows: OrderTotalsSummaryValueRow[] = [];

  if (hasRecordedValue(totals.grossValue)) {
    rows.push(
      {
        key: 'itemGrossValue',
        label: LangEnum.GLOBAL_ITEM_GROSS_VALUE,
        value: totals.grossValue,
      },
      {
        key: ITEM_DISCOUNTS_ROW_KEY,
        label: LangEnum.GLOBAL_ITEM_DISCOUNTS,
        value: totals.grossValue - totals.subtotal,
        prefix: '(-)',
        sign: '-',
      },
    );
  }

  rows.push({
    key: 'totalGrossValue',
    label: LangEnum.GLOBAL_TOTAL_GROSS_VALUE,
    value: totals.subtotal,
    prefix: '(=)',
  });

  const compositions = totals.priceComposition ?? [];

  compositions.forEach((composition, index) => {
    rows.push({
      key: `${PRICE_COMPOSITION_ROW_PREFIX}${composition.id}`,
      label: LangEnum.GLOBAL_ITEM_GROSS_VALUE,
      labelText: composition.label,
      value: composition.price,
      isNested: true,
      isLastNested: index === compositions.length - 1,
    });
  });

  rows.push({
    key: DISCOUNTS_ROW_KEY,
    label: LangEnum.GLOBAL_DISCOUNTS,
    value: totals.discount,
    prefix: '(-)',
    sign: '-',
  });

  if (showShippingCost && hasRecordedValue(totals.totalShippingCostValue)) {
    rows.push({
      key: 'shippingCost',
      label: LangEnum.GLOBAL_SHIPPING_COST,
      value: totals.totalShippingCostValue,
      prefix: '(+)',
      sign: '+',
    });
  }

  if (showCharges && hasRecordedValue(totals.totalChargesValue)) {
    rows.push({
      key: 'charges',
      label: LangEnum.GLOBAL_CHARGES,
      value: totals.totalChargesValue,
      prefix: '(+)',
      sign: '+',
    });
  }

  rows.push({
    key: TOTAL_NET_VALUE_ROW_KEY,
    label: LangEnum.GLOBAL_TOTAL_NET_VALUE,
    value: totals.total,
    prefix: '(=)',
    isEmphasized: true,
  });

  return rows;
};
